// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { media, UNSAFE_media } from "@atlaskit/primitives/responsive";

import { Link, LinkProps } from "../../../components/wpl/link/src/index";

import { componentStyle } from "./global-footer-top";

// ==================================================================
// Style Functions
// ==================================================================
const listOfLinksColumnStyle = css`
    ${UNSAFE_media.below.sm} {
        width: 50%;
    }

    ${UNSAFE_media.only.sm} {
        width: 25%;
    }

    ${media.above.md} {
        width: 16.66666%;
    }

    position: relative;
    min-height: 1px;
    padding: 16px;
    margin: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    display: block;
    color: #091e42;
    box-sizing: border-box;
`;

const listOfLinksUlStyle = css`
    fill: #00000000;
    margin-bottom: 0;
    list-style-type: disc;
    padding-left: 20px;
    list-style: none;
`;

const listOfLinksUlLiStyle = css`
    margin-bottom: 0;
    list-style-type: none;
    margin-left: -20px;
    color: inherit;
    font-size: 1rem;
    line-height: 1.5;
`;

const listOfLinksUlLiAnchorTagStyle = css`
    color: #42526e;
    font-size: 0.875rem;
    line-height: 1.125;
    text-decoration: none;
    vertical-align: baseline;

    &:hover {
        text-decoration: underline;
        text-shadow: none;
    }

    &:visited,
    &:focus {
        text-shadow: none;
    }
`;

const listOfLinksColumnHeaderStyle = css`
    font-size: 14px;
    letter-spacing: 1px;
    margin-bottom: 20px;
    margin-top: 0;
    color: #42526e;
    light-height: 1.25;
    text-transform: uppercase;
    font-weight: 700;

    ${media.above.md} {
        margin-bottom: 24px;
    }
`;

const bottomViewAllLinkLiStyle = css`
    margin-top: 16px;
    margin-bottom: 0;
    list-style-type: none;
    margin-left: -20px;
    color: inherit;
    font-size: 1rem;
    line-height: 1.5;
`;

const bottomViewAllLinkLiAnchorStyle = css`
    color: #0052cc;
    font-size: 0.875rem;
    line-height: 1.125;
    text-decoration: none;
    vertical-align: baseline;

    &:hover,
    &:visited,
    &:focus {
        text-decoration: underline;
    }
`;

// ==================================================================
// Logo Link Props
// ==================================================================
export type LinkListProps = {
    readonly headerText: string;
    readonly listOfLinks: LinkProps[];
    readonly bottomViewAllLink: LinkProps;
};

// ==================================================================
// Rendering Functions
// ==================================================================
export const LinkListContainer = ({
    headerText,
    listOfLinks,
    bottomViewAllLink
}: LinkListProps) => {
    return (
        <div css={listOfLinksColumnStyle}>
            <div css={componentStyle}>
                <h3 css={listOfLinksColumnHeaderStyle}>
                    {headerText.trim().toUpperCase()}
                </h3>
            </div>
            <div css={componentStyle}>
                <ul css={listOfLinksUlStyle}>
                    {listOfLinks.map((listOfLink) => (
                        <li
                            css={listOfLinksUlLiStyle}
                            key={listOfLink.text.trim().replace(" ", "-")}
                        >
                            <Link
                                css={listOfLinksUlLiAnchorTagStyle}
                                text={listOfLink.text}
                                href={listOfLink.href}
                                type="anchor"
                                customLinkColor="n500"
                                bgColor={listOfLink.bgColor}
                                onClick={listOfLink.onClick}
                                className={listOfLink.className}
                            />
                        </li>
                    ))}
                    <li
                        css={bottomViewAllLinkLiStyle}
                        key={bottomViewAllLink.text.trim().replace(" ", "-")}
                    >
                        <Link
                            css={bottomViewAllLinkLiAnchorStyle}
                            text={bottomViewAllLink.text}
                            href={bottomViewAllLink.href}
                            type="anchor"
                            customLinkColor={bottomViewAllLink.customLinkColor}
                            bgColor={bottomViewAllLink.bgColor}
                            onClick={bottomViewAllLink.onClick}
                            className={bottomViewAllLink.className}
                        />
                    </li>
                </ul>
            </div>
        </div>
    );
};
